import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

export default function LinearProgressComponent() {
    return (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
    );
}
